export default __webpack_public_path__ + "b7fae66576c853d2984761b68a277103.svg";